import React, { RefObject, useCallback, useEffect, useState } from 'react';
import { icons } from '@naf/theme';
import { SubdirectoryArrowRight } from '@styled-icons/material-outlined/SubdirectoryArrowRight';
import { Text, TextVariant } from '@naf/text';
import { useNavigate, useLocation } from 'react-router';
import { Link } from '@naf-simba/elements-links';
import * as S from './TableOfContents.styles';

interface TableOfContentsProps {
  tagType: string;
  parentElement?: RefObject<HTMLElement>;
  title?: string;
}

const TableOfContents = ({ tagType = 'h2', parentElement, title }: TableOfContentsProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [toC, setToC] = useState<Element[]>([]);

  const generateTableOfContents = useCallback(() => {
    if (typeof window !== 'undefined' && document) {
      const toCParent = parentElement?.current || document;
      let headings = Array.from(toCParent.getElementsByTagName(tagType));

      // To avoid errors when empty h2 tags are present.
      headings = headings.filter((entry) => {
        const text = entry.textContent?.trim();
        return entry.id && text && text.length > 0;
      });

      setToC(headings);
    }
  }, [parentElement, tagType]);

  useEffect(() => {
    generateTableOfContents();
  }, [generateTableOfContents]);

  if (toC && toC.length > 0) {
    return (
      <S.ToCWrapper aria-label="Innholdsfortegnelse">
        <S.ToCHeading>
          <SubdirectoryArrowRight size={icons.m} />
          <Text variant={TextVariant.Header3}>{title || 'I denne artikkelen'}</Text>
        </S.ToCHeading>
        <ul>
          {toC.map((heading: Element) => {
            // Not innerText: it is empty while the page is visibility: hidden (Webtrends Optimize does this on load).
            const headingText = heading.textContent?.trim() ?? '';
            return (
              <li key={`toc-${heading.id}`}>
                <Link
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    navigate(`${location.pathname}#${heading.id}`);
                  }}
                  href={`${location.pathname}#${heading.id}`}
                  text={headingText}
                  size="medium"
                />
              </li>
            );
          })}
        </ul>
      </S.ToCWrapper>
    );
  }
  return null;
};

export default TableOfContents;
